<template>
  <div class="filter-panel">
    <component
      :is="filterType(filter)"
      v-for="(filter, key) in filters"
      :key="key"
      v-model="filterValues"
      :products="products"
      :filter="filter"
    />
  </div>
</template>

<script>
import GenericFilterSelect from '../components/filters/generic-filter-select'
import GenericFilterRangeSlider from '../components/filters/generic-filter-range-slider'
import GenericFilterchecklist from '../components/filters/generic-filter-check-list'

export default {
  name: 'wine-catalog-filter-panel-view',
  components: {
    'generic-filter-select': GenericFilterSelect,
    'generic-filter-range-slider': GenericFilterRangeSlider,
    'generic-filter-check-list': GenericFilterchecklist
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    filterValues: {
      get: function() {
        return this.value
      },
      set: function(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    filterType: function(filter) {
      return 'generic-filter-' + filter.type
    }
  }
}
</script>

<style scoped lang="scss">
    .filter-panel {
      padding-top:1em;
      h3 {
        border-bottom: 1px solid var(--main-border-color);
        padding-bottom: 1em;
        margin-bottom: 1em;
      }
    }

</style>
